import * as types from './mutation-types'

const namespaced = true

const initialState = {
  list: [],
  dates: [],
  mainDates: [],
  currentDate: '',
  // use to check if current date has changed and if specfic chambers landing models need to be updated
  houseDate: '',
  senateDate: ''
}

const mutations = {
  [types.PUT_AGGREGATE_MODELS] (state, models) {
    state.list = models
  },
  [types.SET_DATES] (state, dates) {
    state.dates = dates
  },
  [types.SET_MAIN_DATES] (state, mainDates) {
    state.mainDates = mainDates
  },
  [types.SET_CURRENT_DATE] (state, date) {
    state.currentDate = date
  },
  [types.SET_HOUSE_DATE] (state, date) {
    state.houseDate = date
  },
  [types.SET_SENATE_DATE] (state, date) {
    state.senateDate = date
  }
}

const actions = {
  list (context) {
    fetch('https://forecasting-data.decisiondeskhq.com/2018/prod/aggregateModels.json')
      .then(response => response.json())
      .then(data => {
        const models = data
        context.commit(types.PUT_AGGREGATE_MODELS, data)
        // remove duplicate dates
        const dates = models.map(model => model.date).reduce((x, y) => x.includes(y) ? x : [...x, y], [])
        dates.sort((a, b) => {
          return a.localeCompare(b)
        })
        context.commit(types.SET_DATES, dates)
        const mainDates = models.filter(model => model.mainModel)
          .map(model => model.date).reduce((x, y) => x.includes(y) ? x : [...x, y], [])
        if (!models[0].mainModel) {
          mainDates.unshift(models[0].date)
        }
        mainDates.sort((a, b) => {
          return a.localeCompare(b)
        })
        context.commit(types.SET_MAIN_DATES, mainDates)
        if (context.state.currentDate === '') {
          context.commit(types.SET_CURRENT_DATE, dates[dates.length - 1])
          context.commit(types.SET_HOUSE_DATE, dates[dates.length - 1])
          context.commit(types.SET_SENATE_DATE, dates[dates.length - 1])
        }
        return models
      })
      .catch(error => console.error(error))
  },
  setCurrentDate: ({ commit }, date) => {
    commit(types.SET_CURRENT_DATE, date)
  },
  setHouseDate: ({ commit }, date) => {
    commit(types.SET_HOUSE_DATE, date)
  },
  setSenateDate: ({ commit }, date) => {
    commit(types.SET_SENATE_DATE, date)
  }
}

const getters = {
  list (state) {
    return state.list
  },
  dates (state) {
    return state.dates
  },
  mainDates (state) {
    return state.mainDates
  },
  currentDate (state) {
    return state.currentDate
  },
  houseDate (state) {
    return state.houseDate
  },
  senateDate (state) {
    return state.senateDate
  }
}

export default {
  namespaced,
  state: initialState,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/modules/aggregate-models.js